import Slider, { SliderProps } from '@mui/material/Slider'

export default function APSlider(props: SliderProps) {
    return (
        <Slider {...props} />
    )
}
